import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import type { Registrant } from '../types';

interface RegisterFormDraft {
  fullname: string;
  mothersName: string;
  dateOfBirth: unknown;
  documentType: string;
  docNo: string;
  docExpiryDate: unknown;
  companyName: string;
  phoneNumber: string;
  expiry: string;
}

interface FormState {
  registrationType: string;
  registeredPersons: Registrant[];
  isVideoWatched: boolean;
  registerForm: RegisterFormDraft;
  changeRegistrationType: (registrationType: string) => void;
  setRegisteredPersons: (registeredPersons: Registrant[]) => void;
  setVideoWatched: () => void;
  setRegisterForm: (registerForm: RegisterFormDraft) => void;
  clearRegisterForm: () => void;
  changeRegistrantVideoStatus: (params: {
    registrantDocNo: string;
    videoStatus: string;
  }) => void;
  resetProcess: () => void;
}

const INITIAL_REGISTER_FORM: RegisterFormDraft = {
  fullname: '',
  mothersName: '',
  dateOfBirth: null,
  documentType: '',
  docNo: '',
  docExpiryDate: null,
  companyName: '',
  phoneNumber: '',
  expiry: ''
};

export const useFormStore = create<FormState>()(
  devtools(
    persist(
      (set) => ({
        registrationType: '',
        registeredPersons: [],
        isVideoWatched: false,
        registerForm: INITIAL_REGISTER_FORM,
        changeRegistrationType: (registrationType) => set({ registrationType }),
        setRegisteredPersons: (registeredPersons) => set({ registeredPersons }),
        setVideoWatched: () => set({ isVideoWatched: true }),
        setRegisterForm: (registerForm) => set({ registerForm }),
        clearRegisterForm: () => set({ registerForm: INITIAL_REGISTER_FORM }),
        changeRegistrantVideoStatus: ({ registrantDocNo, videoStatus }) =>
          set((state) => ({
            registeredPersons: state.registeredPersons.map((person) =>
              person.docNo === registrantDocNo
                ? { ...person, videoStatus }
                : person
            )
          })),
        resetProcess: () =>
          set({
            registrationType: '',
            registeredPersons: [],
            isVideoWatched: false,
            registerForm: INITIAL_REGISTER_FORM
          })
      }),
      {
        name: 'form-store',
        partialize: (state) => ({
          registrationType: state.registrationType,
          registeredPersons: state.registeredPersons,
          isVideoWatched: state.isVideoWatched,
          registerForm: state.registerForm
        })
      }
    ),
    { name: 'FormStore' }
  )
);
